import type { Principal } from './principal.js';
import { isPrivileged } from './principal.js';
import { hasWorkingAccess } from './principal.js';

export const AUDIENCE_PURPOSES = ['view', 'raise'] as const;
export type AudiencePurpose = (typeof AUDIENCE_PURPOSES)[number];

export const AUDIENCE_KINDS = ['department', 'position', 'person'] as const;
export type AudienceKind = (typeof AUDIENCE_KINDS)[number];

export interface AudienceRule {
  readonly kind: AudienceKind;
  readonly departmentId: string | null;
  readonly departmentSlug: string | null;
  readonly jobRoleId: string | null;
  readonly userId: string | null;
}

export function matchesAudience(
  principal: Principal,
  rules: readonly AudienceRule[],
): boolean {
  if (rules.length === 0) return true;
  if (isPrivileged(principal)) return true;

  return rules.some((rule) => {
    switch (rule.kind) {
      case 'person':
        return rule.userId === principal.id;
      case 'position':
        return rule.jobRoleId === principal.jobRoleId;
      case 'department':
        return rule.departmentSlug !== null && hasWorkingAccess(principal, rule.departmentSlug);
    }
  });
}

export interface RoutingTarget {
  readonly kind: AudienceKind;
  readonly departmentId: string | null;
  readonly jobRoleId: string | null;
  readonly userId: string | null;
}
